import React from 'react';
import NetworkStatus from './NetworkStatus';
import DebugButton from './DebugButton';
import BookmarkLinkButton from './BookmarkLinkButton';
import StatsButton from './Stats/StatsButton';
import LeaderboardButton from './Leaderboard/LeaderboardButton';
import './FancyButton.css';

type HeaderProps = {
  onToggleDebug: () => void;
  onShowStats: () => void;
  onShowLeaderboard: () => void;
  lastUpdated?: string | Date | null;
  pollInterval?: number;
  loading?: boolean; // NEW: show spinner if true
};

const Header: React.FC<HeaderProps> = ({onToggleDebug, onShowStats, onShowLeaderboard, lastUpdated, pollInterval = 2000, loading }) => {

  return (
    <header
      className="header panel"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'var(--space-md) var(--space-md)',
        minHeight: 0,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)' }}>
        <h1 style={{ 
          margin: 0, 
          fontSize: 'var(--font-size-3xl)', 
          letterSpacing: '1px', 
          fontWeight: 'var(--font-weight-bold)',
          fontFamily: 'Orbitron, var(--font-family-display), Arial, sans-serif'
        }}>
          Idle Fleet
        </h1>

        {loading && (
          <div style={{ marginLeft: 12, display: 'flex', alignItems: 'center', height: 32 }}>
            {/* Compact spinner, no text */}
            <div className="spinner-animation" style={{ width: 22, height: 22, margin: 0 }} />
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: 'var(--space-sm)', alignItems: 'center' }}>
        <BookmarkLinkButton />
        <StatsButton onClick={onShowStats} />
        <LeaderboardButton onClick={onShowLeaderboard} />
        <DebugButton onClick={onToggleDebug} />
        <NetworkStatus lastUpdated={lastUpdated || null} pollInterval={pollInterval} />
      </div>
    </header>
  );
};

export default Header;